// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require("./../Sass/base.scss");

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require("babel-polyfill");

import * as helper from "../../../Assets/Js/helper";
import { chatFrameHandler } from "../../../Assets/Js/ChatFrameHandler";
import { initImprint } from "../../../Assets/Js/VXImprint";
import axios from "axios";
import { CDNHandler } from "../../../Assets/Js/CDNHandler";

helper.onDocumentLoaded(async () => {
	const impressumLink = helper.$("#impressumlink");
	const datenschutzLink = helper.$("#datenschutzlink");
	const ab1 = !!helper.hasClass(document.body, "ab11");
	const ab4 = parseInt(helper.getData(helper.$("#backdrop"), "ab4"));
	const ab5 = parseInt(helper.getData(helper.$("#backdrop"), "ab5"));
	const pt = parseInt(helper.getData(helper.$("#backdrop"), "pt"));
	const hasAVSCookie = parseInt(helper.getData(helper.$("#backdrop"), "cookie"), 10);
	const titleElement = document.getElementById("main-title");
	const cdn = new CDNHandler();
	const domain = await cdn.getMainDomain();
	const videoElement = document.getElementById("teaservideo");

	let collage = "";

	chatFrameHandler(ab4);
	initImprint(impressumLink, datenschutzLink);

	helper.removeClass(helper.$("#step1"), "hidden");

	let paytourSettings: any = {
		targetUrl: "",
		pfm: 1502,
		host: 0,
		hideClose: true,
		minAmount: 2500, // cents
		disableJump: true,
	};

	if (ab1) {
		paytourSettings = {
			lpId: "ConversionChatGeneric",
			hideSignupConfirmation: true,
			targetUrl: "",
			pfm: 1502,
			host: 0,
			hideClose: true,
			minAmount: 2500, // cents
			disableJump: true,
			texts: {
				BonusTextCustom: " ",
			},
			conversion: {
				signup: {
					headerClassMobile: "conversion-chat",
					headerHeadlineMobile: "GRATIS WEBCAM", // hier den neuen Text,
					headerSubheadlineMobile: "echte Amateure & bekannte Erotikstars",
					background:
						"https://www.visit-x.net/assets/img/teaser/conversion-chat/vxpay-conversion-chat-signup-lexyroxx.jpg", // hier das Bild ersetzen
					backgroundMobile:
						"https://www.visit-x.net/assets/img/teaser/conversion-chat/vxpay-conversion-chat-signup-mobile-lexyroxx.png", // hier das Bild ersetzen				}
				},
			},
		};
	}

	if (ab5 === 0 || ab5 === 1) {
		paytourSettings.option = "2XITGA";
	} else {
		paytourSettings.pc = "10MVX4F";
	}

	if (hasAVSCookie === 1) {
		paytourSettings.signupParams = {
			az: true,
		};
	}

	if (pt === 0) {
		paytourSettings.hideSignupConfirmation = true;
	}

	for (let n = 1; n <= 7; n++) {
		let buttons = helper.$("#step" + n + " a.btn");
		for (let button of buttons) {
			helper.addEventListener(button, "click", (e) => {
				e.preventDefault();
				const target: HTMLAnchorElement = e.target;
				const title = target.parentElement.querySelector("h1").innerText;
				const text = target.innerText;

				axios.post(
					window.location.href,
					{
						ns: "Umfrage3",
						key: title,
						value: text,
					},
					{ headers: { "X-Requested-With": "XMLHttpRequest" } }
				);

				const collageString = helper.getData(target, "collage");
				if (collageString !== null && collageString !== undefined && collage === "") {
					collage = collageString;
				}

				helper.addClass(helper.$("#step" + n), "hidden");
				helper.removeClass(helper.$("#step" + (1 + n)), "hidden");

				if (ab5 !== 1 && n > 0) {
					videoElement.setAttribute("hidden", "");
				}

				if (n !== 0) {
					titleElement.setAttribute("hidden", "");
				}

				if (n === 7) {
					videoElement.setAttribute("hidden", "");

					helper.addClass(document.querySelector(".loaderbar-progress"), "grow");
					helper.wait(5).then(() => {
						if (pt === 0 || ab1) {
							(window as any).paytourHelper.openSignup(paytourSettings);
						} else {
							if (collage === "") {
								collage = "Normal";
							}
							let headline;
							switch (collage) {
								case "BBW":
									headline =
										"Bis zu 100€ Bonus von Deinem kurvenreichen Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								case "BDSM":
									headline =
										"Bis zu 100€ Bonus von Deinem schlagfertigen Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								case "Boobs":
									headline =
										"Bis zu 100€ Bonus von Deinem prallen Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								case "MILF":
									headline =
										"Bis zu 100€ Bonus von Deinem reifen Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								case "Porno":
									headline =
										"Bis zu 100€ Bonus für Deine Lieblingspornos warten auf Dich! Beeil Dich!";
									break;
								case "Teen":
									headline =
										"Bis zu 100€ Bonus von Deinem knackigen Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								case "Tattoo":
								case "Piercing":
									headline =
										"Bis zu 100€ Bonus von Deinem schmucken Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
								default:
									headline =
										"Bis zu 100€ Bonus von Deinem sexy Lieblingsgirl warten auf Dich! Beeil Dich!";
									break;
							}
							paytourSettings = Object.assign(paytourSettings, {
								conversion: {
									signup: {
										headerHeadlineMobile: headline, // hier den neuen Text,
										background: `https://${domain}/VX/Umfrage3/img/collage/${collage}-Collage.png`,
										backgroundMobile: `https://${domain}/VX/Umfrage3/img/collage/${collage}_mobil.jpg`,
										backgroundMobileWidth: 120,
									},
								},
							});

							if (pt === 0) {
								(window as any).paytourHelper.openSignup(paytourSettings);
							} else {
								(window as any).paytourHelper.openPaytour(paytourSettings);
							}
						}
					});
				}
			});
		}
	}
});
